// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__21Hmc","containerItemsCenter":"Skeleton_containerItemsCenter__26ohQ"};